<div class="nav-content" data-cy="ActionBarNav:parentRoutes">
  <!-- project section -->

  <div class="parent-route">
    <div class="project-and-group-info">
      @if (projectGroupName()) {
        <div class="project-group-name">{{ projectGroupName() }}</div>
      } @else if (currentProject()?.projectGroupId) {
        <div class="project-group-name h-16"></div>
      }
      <a (click)="currentProject() && navigateToCurrentProject()" class="route-label">
        {{ currentProject()?.name }}
      </a>
    </div>

    @if (hasProjectOptions() || areProjectsLoading()) {
      <div class="route-select" data-cy="ActionBarNav:projectsMenuChevron">
        <blaze-picker
          dataCy="ActionBarNav:projectsMenu"
          [options]="projectPickerOptions()"
          [value]="currentProject()?.id"
          [disabled]="areProjectsLoading()"
          [itemTemplate]="projectItemTemplate"
          (selectionChange)="projectClick($event)"
          ariaLabel="Select Project"
        >
          <div class="menu-chevron-icon">
            <mat-icon svgIcon="icon_chevron_down_16" class="icon-16" />
          </div>
        </blaze-picker>
      </div>
    }

    @if (hasPageOptions()) {
      <div class="divider ml-8">/</div>
    }
  </div>

  <!-- page section -->
  @if (hasPageOptions()) {
    <div class="parent-route">
      <a (click)="currentPage() && navigateToCurrentPage()" class="route-label">
        {{ currentPage()?.name }}
      </a>

      <div class="route-select" data-cy="ActionBarNav:pagesMenuChevron">
        <blaze-picker
          dataCy="ActionBarNav:pagesMenu"
          [options]="pagePickerOptions()"
          [value]="pageId()"
          (selectionChange)="pageClick($event)"
          ariaLabel="Select Page"
        >
          <div class="menu-chevron-icon">
            <mat-icon svgIcon="icon_chevron_down_16" class="icon-16" />
          </div>
        </blaze-picker>
      </div>
    </div>
  }
</div>

<ng-template #projectItemTemplate let-opt let-selected="selected">
  <div
    [attr.data-cy]="'ActionBarNav:projectMenuItem-' + opt.value"
    class="project-row"
    [class.current-project]="selected"
  >
    <div [style.backgroundColor]="opt.dataBag?.projectSettingsInfo?.color" class="project-icon">
      <mat-icon
        [svgIcon]="opt.dataBag?.projectSettingsInfo?.icon || 'icon_blaze_16'"
        class="icon-16"
      />
    </div>
    <div [title]="opt.label" class="project-name-label">{{ opt.label }}</div>
    @if (selected) {
      <div class="current-project-checkmark">
        <mat-icon svgIcon="icon_checkmark_16" />
      </div>
    }
  </div>
</ng-template>
